import { render } from "./CoderpixPopup.vue?vue&type=template&id=8fc22820"
import script from "./CoderpixPopup.vue?vue&type=script&lang=js"
export * from "./CoderpixPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__